import { required } from 'vuelidate/lib/validators'

export default {
  speciality: {
    speciality_id: {
      required
    },
    rqe: {
      required
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/professional/record/specialities/form/resources/validations.js